/**
 *  TODO use import { importAngularDependenciesRegExp } from "../../../modules/core";
 *  now it comes with Warning(Critical dependency: require function is used in a way in which dependencies cannot be statically extracted)
 * */
const dependencies = importAngularDependencies(
  require.context('./', true, /^(?!.*\.(spec|test)\.(js|ts)$).*\.(js|ts)$/),
  './providers.common.js'
);

export default angular.module('doxy.providers.video.common', dependencies).name;
